import React from 'react';
import styles from '../../assets/styles/LandingPage/Testimonials.module.scss';
import { motion, AnimatePresence } from 'framer-motion';

import { IoIosArrowForward } from "react-icons/io";
import { IoIosArrowBack } from "react-icons/io";

const Testimonials = ({toPrev, toNext, toSlide, slides, currentIndex, setAutoPlay, timeOut}) => {

	return (
		<section className={styles.testimonials} id="testimonial">
			<div className={styles.testimonials__slideBox}
				onMouseEnter={() => {
					setAutoPlay(false);
					clearTimeout(timeOut);
				}}
				onMouseLeave={() => {
					setAutoPlay(true);
				}}
			>
				<div className={styles.testimonials__slide}>
					<div className={styles.testimonials__slide_crumbBox}>
						{
							slides.map((_, slideIndex) => (
								
								<span 
									key={slideIndex}
									onClick={() => toSlide(slideIndex)}
									className={`${styles.testimonials__slide_crumb}`}
									style={{
										opacity: currentIndex === slideIndex ? '1' : '0.25'
									}}
								>
								</span>
							))
						}
					</div>

					<div className={styles.testimonials__slide_content}>
						<IoIosArrowBack 
							className={styles.testimonials__slide_prev} onClick={toPrev}
						/>
						<IoIosArrowForward 
							className={styles.testimonials__slide_next} onClick={toNext}
						/>
						<div className={styles.testimonials__slide_main}>
							<div className={styles.testimonials__slide_img}>
								<div className={styles.testimonials__slide_img_shape}></div>
								
								<AnimatePresence initial={false} exitBeforeEnter>
									<motion.img
										src={slides[currentIndex].imgUrl}
										className={styles.testimonials__slide_img_main}
										alt="Testimonial 1"
										key={currentIndex}
										exit={{ opacity: 0 }}
										initial={{ opacity: 0 }}
										animate={{ opacity: 1 }}
										transition={{ ease: 'easeIn'}}
									/>
								</AnimatePresence>
								
							</div>
							<AnimatePresence initial={false} exitBeforeEnter>
								<motion.div 
									className={styles.testimonials__slide_texts}
									key={currentIndex}
									exit={{ x: 0, opacity: 0 }}
									initial={{ x: 0, opacity: 0 }}
									animate={{ x: 0, opacity: 1 }}
									transition={{ ease: 'easeIn'}}
								>
									<p className={styles.testimonials__slide_texts_desc}>
										{slides[currentIndex].testimony}
									</p>
									<p className={styles.testimonials__slide_texts_name}>
										{slides[currentIndex].name}
									</p>
									<p className={styles.testimonials__slide_texts_business}>
										{slides[currentIndex].business}
									</p>
								</motion.div>
							</AnimatePresence>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Testimonials;